import PosterUsersList from './PosterUsersList'

export default { list: PosterUsersList }
